module.exports = __webpack_public_path__ + "img/3.745efd4e.png";